// 相対時間を日本語で返す関数
export function getRelativeTime(dateString: string): string {
    const now = new Date();
    const date = new Date(dateString);
    const diff = Math.floor((now.getTime() - date.getTime()) / 1000);
    if (Math.abs(diff) <= 1) return 'ちょうど今';
    if (diff > 1) {
        if (diff < 60) return `${diff}秒前`;
        if (diff < 3600) return `${Math.floor(diff / 60)}分前`;
        if (diff < 86400) return `${Math.floor(diff / 3600)}時間前`;
        if (diff < 2592000) return `${Math.floor(diff / 86400)}日前`;
        if (diff < 31536000) return `${Math.floor(diff / 2592000)}か月前`;
        return `${Math.floor(diff / 31536000)}年前`;
    } else {
        const future = Math.abs(diff);
        if (future < 60) return `${future}秒後`;
        if (future < 3600) return `${Math.floor(future / 60)}分後`;
        if (future < 86400) return `${Math.floor(future / 3600)}時間後`;
        if (future < 2592000) return `${Math.floor(future / 86400)}日後`;
        if (future < 31536000) return `${Math.floor(future / 2592000)}か月後`;
        return `${Math.floor(future / 31536000)}年後`;
    }
}

// 日付を日本語で返す関数
export function formatJapaneseDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}年${month}月${day}日`;
}